import { RefreshCw, AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useQuickCreate } from "@/context/QuickCreate";
import { cn } from "@/lib/utils";

const relative = (iso) => {
  if (!iso) return "henüz eşitlenmedi";
  const diff = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (diff < 60) return "az önce";
  if (diff < 3600) return `${Math.floor(diff / 60)} dk önce`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} sa önce`;
  return new Date(iso).toLocaleString("tr-TR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
};

export const SyncBar = ({ label = "Yenile" }) => {
  const { sync, syncing, syncError, lastSync } = useQuickCreate();

  return (
    <div className="space-y-2">
      <div className="flex flex-wrap items-center gap-3">
        <Button variant="outline" size="sm" onClick={() => sync()} disabled={syncing} data-testid="sync-refresh-btn">
          <RefreshCw className={cn("h-4 w-4", syncing && "animate-spin")} /> {label}
        </Button>
        <span className="text-xs text-muted-foreground" data-testid="sync-status">
          {syncing ? (
            <span className="inline-flex items-center gap-1.5">
              <RefreshCw className="h-3 w-3 animate-spin" /> Google Sheet ile eşitleniyor…
            </span>
          ) : (
            <>Son eşitleme: <span className="font-mono">{relative(lastSync)}</span></>
          )}
        </span>
      </div>
      {syncError && !syncing && (
        <div
          className="flex flex-wrap items-center gap-3 rounded-xl border border-crimson/30 bg-crimson/5 p-3 text-sm text-crimson"
          data-testid="sync-error"
        >
          <AlertTriangle className="h-4 w-4 shrink-0" />
          <span>{syncError} Mevcut kayıtlar korundu.</span>
          <Button variant="outline" size="sm" onClick={() => sync()} data-testid="sync-retry-btn">
            Tekrar dene
          </Button>
        </div>
      )}
    </div>
  );
};
